import ModuleInvoice from "./ModuleInvoice.vue";

export default ModuleInvoice